export default __webpack_public_path__ + "static/media/converse-M.aa768ed0.png";